import ValidatePage from '@/router/modules/methods/validate'

export default {
    path: '/success',
    name: 'AppSuccess',
    component: () => import('@/views/success/index.vue'),
    meta: {
        title: 'Выбор оплаты',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await ValidatePage(next)
    }
}